import apiClient from '../api/apiClient';
import { CurrentUserSecurity } from '../Types/Security';

export const getCurrentUserSecurity = async (): Promise<CurrentUserSecurity> => {
  const response = await apiClient.get<CurrentUserSecurity>('/api/security/me');
  return response.data;
};
